import API from '@/shared/plugins/Api/API'
import Alerts from './Alerts'

class ALERTING extends API {
  constructor (id) {
    super(id)
    this.alerts = new Alerts(id)
  }
}
export default ALERTING
